import { Carousel, Col, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Images from 'app/assets/img';
import { ReactComponent as BackIcon } from 'app/assets/img/arrow.svg';
import { ReactComponent as ArrowDown } from 'app/assets/img/arrow_down.svg';
import { ReactComponent as ForkAndSpoonIcon } from 'app/assets/img/ForkandSpoon.svg';
import StyledTable from 'app/components/StyledTable';
import { Permission } from 'app/hooks/usePermission';
import useWindowSize, { TABLET_WIDTH } from 'app/hooks/useWindowSize';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import { Layout } from 'app/pages/NewAccount/layouts';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import {
  OrderInfoView,
  TicketType,
} from 'app/pages/NewAccount/layouts/ListTicketLayout';
import { OrderState } from 'app/pages/NewAccount/types';
import { get, groupBy, isEmpty } from 'lodash';
import moment from 'moment';
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { DateFormat } from 'utils/date-utils/date-format';
import { DateFromToUtils } from 'utils/date-utils/date-utils';
import { formatNumber, formatTimeFrame } from 'utils/helper';
import useScrollIntoElement from 'utils/hooks/useScrollIntoElement';
import { APPROVAL_ORDER_STATUS } from '../ApproveOrder';
import StyledButton from 'app/components/StyledButton';
import useApproveOrder from '../ApproveOrder/useApproveOrder';
import WarningMsg from '../ApproveOrder/WarningMsg';
import { LoadingContainer } from 'app/components/LoadingContainer';
import useGetDetailTicket from '../hooks/useGetDetailTicket';
import { StyledStack } from 'app/components/Stack';
import { BOOKING_METHODS, getBookingMethodStr } from '../../Restaurants/config';
import { buildRestaurantDetailUrl } from '../../Restaurants/store';
import { format, parse } from 'date-fns';

const getTotalAmount = (ticketnfo: Array<{ amount: number }>) => {
  if (!ticketnfo) return 0;
  return ticketnfo.reduce((total, ticket) => total + (ticket.amount || 0), 0);
};

const DetailTicket = ({ orderState }: { orderState: OrderState }) => {
  const infoUser = useSelector(selectInfoUser);
  const translations = useSelector(selectTranslations);
  const { device } = useWindowSize();
  const { locale } = useGlobalFunction();
  const [ticket, setTicket] = useState<TicketType>();
  const [screen, setScreen] = useState<string>();

  const giftsAnchorTable = useRef<HTMLDivElement>(null);
  const ticketListAnchorTable = useRef<HTMLDivElement>(null);
  const listCustomerAnchorTable = useRef<HTMLDivElement>(null);

  const { onScrollIntoElement: onScrollIntoElementGifts } =
    useScrollIntoElement({
      elementRef: giftsAnchorTable,
    });
  const { onScrollIntoElement: onScrollIntoElementTicketList } =
    useScrollIntoElement({
      elementRef: ticketListAnchorTable,
    });
  const { onScrollIntoElement: onScrollIntoElementListCustomer } =
    useScrollIntoElement({
      elementRef: listCustomerAnchorTable,
    });

  const history = useHistory();
  const listCustomers = useMemo(() => {
    // console.log('ticket?.ticketsInfo: ', ticket?.ticketsInfo);

    const ticketBuyer =
      ticket?.ticketsInfo?.flatMap(val => val.dataBuyer) ?? [];
    const giftBuyer = ticket?.giftsInfo?.flatMap(val => val.dataBuyer) ?? [];

    return [...ticketBuyer, ...giftBuyer];
  }, [ticket?.ticketsInfo, ticket?.giftsInfo]);
  const location = useLocation();
  const groupedByUsedArea2Label = useMemo(() => {
    const group = groupBy(ticket?.items, val => val.show?.usedArea2Label);
    return group;
  }, [ticket]);

  const columns = useMemo(
    () =>
      [
        {
          title: '',
          key: 'restaurantReservation',
          render: dataObject => {
            if (!dataObject?.restaurant || !(getBookingMethodStr(dataObject?.restaurant?.methodsEcom) === BOOKING_METHODS.TICKET_RESERVATION) || !ticket?.isLongTerm) return null;
            return (
              <Tooltip
                title={
                  translations?.['restaurant.card.bookTable'] ??
                  'Đặt bàn'
                }
              >
                <button
                  type="button"
                  aria-label={
                    translations?.['restaurant.card.bookTable'] ??
                    'Đặt bàn'
                  }
                  style={{
                    border: 0,
                    background: 'transparent',
                    padding: 0,
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    history.push(
                      buildRestaurantDetailUrl(
                        dataObject.restaurant.storeEcomId,
                        dataObject.restaurant.bookingRules ??
                          dataObject.restaurant.booking_rules,
                      ),
                    )
                  }
                >
                  <ForkAndSpoonIcon width={18} height={18} />
                </button>
              </Tooltip>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2b.txt.product-name'] : ''}
            </div>
          ),
          key: 'ticketName',
          render: dataObject => {
            return (
              <div style={{ textAlign: 'left' }}>
                {dataObject?.ticketName ?? ''}
              </div>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2b.txt.event-name'] : ''}
            </div>
          ),
          render: dataObject => {
            return (
              <div style={{ textAlign: 'left' }}>
                <TooltipParagraph
                  ellipsis={{ rows: 2 }}
                  style={{
                    maxWidth: 200,
                    marginBottom: 0,
                    textAlign: 'left',
                  }}
                >
                  {!isEmpty(dataObject?.park?.name)
                    ? dataObject?.park?.name?.trim()
                    : ''}
                </TooltipParagraph>
              </div>
            );
          },
          key: 'eventName',
        },
        {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2b.txt.type-ticket'] : ''}
            </div>
          ),
          render: dataObject => {
            return (
              <div style={{ textAlign: 'left' }}>
                <TooltipParagraph
                  ellipsis={{ rows: 2 }}
                  style={{
                    maxWidth: 200,
                    marginBottom: 0,
                    textAlign: 'left',
                  }}
                >
                  {!isEmpty(dataObject?.catalog?.name)
                    ? dataObject?.catalog?.name?.trim()
                    : ''}
                </TooltipParagraph>
              </div>
            );
          },
          key: 'typeName',
        },
        {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2c.txt.date-use'] : ''}
            </div>
          ),
          key: 'useDate',
          render: dataObject => {
            return (
              <div style={{ textAlign: 'left' }}>
                {
                  new DateFromToUtils.Builder(locale, 'DD/MM/YYYY')
                    .setFromDate(
                      dataObject?.ticket?.vgsUsageDate
                        ? DateFormat.create(
                          'YYYY-MM-DD HH:mm',
                          dataObject?.ticket?.vgsUsageDate,
                        ).getMoment()
                        : DateFormat.create(
                          'HH:mm DD/MM/YYYY',
                          dataObject?.useDateFrom,
                        ).getMoment(),
                    )
                    .setToDate(
                      DateFormat.create(
                        'YYYY-MM-DD HH:mm',
                        dataObject?.ticket?.vgsUsageDateTo,
                      ).getMoment(),
                    )
                    .build()
                    .getDateFromTo().concatFromToDate
                }
              </div>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'left', display: 'flex' }}>
              <div>
                {translations ? translations['b2b.txt.ticket-detail'] : ''}{' '}
              </div>
            </div>
          ),
          render: dataObject => {
            return (
              dataObject?.materialType !== '9005' && (
                <div style={{ textAlign: 'left' }}>
                  <Typography>{dataObject?.position || ''}</Typography>
                  <Typography>{dataObject?.restaurant?.name || ''}</Typography>
                  <Typography>
                    {dataObject?.product?.usedArea2Object?.label
                      ? formatTimeFrame(
                        dataObject?.product?.usedArea2Object?.label,
                      )
                      : ''}
                  </Typography>
                </div>
              )
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2c.txt.amount'] : ''}
            </div>
          ),
          key: 'amount',
          render: dataObject => {

            return (
              <div style={{ textAlign: 'center' }}>
                {dataObject?.amount ?? 0}
              </div>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'right' }}>
              {translations ? translations['b2c.txt.unitPrice'] : ''}
            </div>
          ),
          key: 'unitPrice',
          render: dataObject => {
            return (
              <div style={{ textAlign: 'right', color: '#e92127' }}>
                {formatNumber(dataObject.price)}
                {'đ'}
              </div>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'right' }}>
              {translations ? translations['b2c.txt.finalPrice'] : ''}
            </div>
          ),
          key: 'finalPrice',
          render: dataObject => {
            return (
              <div style={{ textAlign: 'right', color: '#e92127' }}>
                {formatNumber(dataObject.totalPrice ?? 0)}
                {'đ'}
              </div>
            );
          },
        },
      ].filter(val => val),
    [
      groupedByUsedArea2Label,
      locale,
      orderState,
      translations,
    ],
  );
  const columnsCustomer: ColumnsType = useMemo(
    () => [
      {
        title: <div style={{ textAlign: 'left' }}>Email</div>,
        key: 'email',
        render: dataObject => {
          const email = dataObject?.email || '';
          return (
            <TooltipParagraph
              style={{
                marginBottom: 0,
                textAlign: 'left',
                maxWidth: '99%',
              }}
            >
              {email}
            </TooltipParagraph>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: 'left' }}>
            {translations ? translations['b2c.txt.identityCard'] : ''}
          </div>
        ),
        key: 'identityCard',
        render: dataObject => {
          return (
            <div style={{ textAlign: 'left' }}>
              {dataObject?.identityCode ?? ''}
            </div>
          );
        },
      },
    ],
    [locale, orderState, translations],
  );
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  useEffect(() => {
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    if (historyState?.ticket) {
      setTicket(historyState?.ticket);
    }
    if (historyState?.screen) {
      setScreen(historyState?.screen);
    }
  }, [location?.state]);

  const isApprovedAdjustedPriceOrFocOrder =
    !!ticket?.adjustedPriceOrFOC &&
    orderState === 'init' &&
    !!ticket?.approvedDate;

  const isOwnerProxyOrder = infoUser?.id === ticket?.agent?.id;
  return (
    <>
      <div>
        {ticket && (
          <OrderInfoView
            ticket={ticket}
            isAbleCancelOrder={
              orderState === 'paymentPending' ||
              isApprovedAdjustedPriceOrFocOrder
            }
            isShowButtonPay={
              isApprovedAdjustedPriceOrFocOrder && isOwnerProxyOrder
            }
            onlyShowPayButton={isApprovedAdjustedPriceOrFocOrder}
            onCancelOrderSuccess={() => {
              // getListOrderOnCancelOrderSuccess?.();
              // onCloseDialog?.();

              history.goBack();
              if (screen === '/account') {
                const unlisten = history.listen((_, action) => {
                  if (action === 'POP') {
                    history.replace(`${screen}?route=tab-3`);
                    unlisten();
                  }
                });
              }
              onOpenDialogNoti({
                onCloseDialog: onCloseDialogNoti,
                type: 'SUCCESS',
                isShow: true,
                maskClosable: false,
                title: '',
                content:
                  translations?.['b2b.txt.cancelOrderSuccess']?.replace(
                    '{orderCode}',
                    ticket.orderInfo.orderId,
                  ) ?? '',
              });
            }}
          />
        )}
      </div>
      {((ticket?.giftsInfo && ticket.giftsInfo.length > 0) ||
        (ticket?.vouchers?.length ?? 0) > 0) && (
          <div>
            <StyledH4
              style={{
                marginTop: 40,
                marginBottom: 24,
                fontSize: 16,
                textTransform: 'unset',
              }}
            >
              <CapitalizeFirst>
                {translations ? translations['b2c.txt.giftInOrder'] : ''}{' '}
              </CapitalizeFirst>
              <CapitalizeFirst>
                {translations?.['b2c.txt.totalTicket']?.replace(
                  '${amount}',
                  `${getTotalAmount(ticket?.giftsInfo ?? [])}`,
                )}
              </CapitalizeFirst>
            </StyledH4>
          </div>
        )}
      {ticket?.giftsInfo && ticket.giftsInfo.length > 0 && (
        <>
          <div ref={giftsAnchorTable} />
          <StyledTable
            dataSource={ticket.giftsInfo.map((val, valIdx) => {
              return { ...val, ticket: val?.orgTickets?.[0] };
            })}
            // dataSource={ticket.giftsInfo.flatMap((val, valIdx) => {
            //   return (
            //     val.orgTickets.length > 0
            //       ? val.orgTickets
            //       : Array.from<any>({ length: val.amount })
            //   ).flatMap((ticket, idx) => ({ ...val, ticket: ticket }));
            // })}
            columns={columns as object[]}
            tableProps={{
              rowKey: (record, index) =>
                `${(record as TicketType)._id}${index}`,
            }}
            styleSlots={{
              td: {
                padding: '15px 10px',
              },
            }}
            // tableProps={rowKey:(record, index) => `${(record as TicketType)._id}${index}`}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['20', '50', '100'],
              onChange: onScrollIntoElementGifts,
            }}
          />
        </>
      )}
      {ticket?.vouchers?.length
        ? ticket.vouchers.map((voucher, idx) => (
          <CouponContainer
            key={`${voucher.code}${idx}`}
            style={{
              marginTop: 24,
              marginBottom: device === 'desktop' ? 0 : 24,
              flexDirection: device === 'desktop' ? 'row' : 'column',
              justifyContent:
                device === 'desktop' ? 'space-between' : 'center',
            }}
            bgImg={Images.BgCoupon}
          >
            <div
              className="title-voucher"
              style={{ marginBottom: device === 'desktop' ? 0 : 5 }}
            >
              {voucher.productName ?? ''}
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#D9D9D980',
                borderRadius: 100,
                height: 30,
                marginTop: device === 'desktop' ? 0 : 5,
              }}
            >
              <div style={{ color: '#808080', margin: '4px 23px 4px 23px' }}>
                {translations ? translations['b2c.txt.codeUse'] : ''}
              </div>
              <div
                style={{
                  backgroundColor: '#E92127',
                  borderRadius: 100,
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  height: 30,
                  color: 'white',
                  padding: '4px 35px 4px 35px',
                }}
              >
                {voucher.code ?? ''}
              </div>
            </div>
          </CouponContainer>
        ))
        : undefined}
      {ticket?.ticketsInfo && ticket.ticketsInfo.length > 0 && (
        <>
          <div>
            <StyledH4
              style={{
                marginTop: 40,
                marginBottom: 24,
                fontSize: 16,
                textTransform: 'unset',
              }}
            >
              <CapitalizeFirst>
                {translations ? translations['b2c.txt.ticketList'] : ''}{' '}
              </CapitalizeFirst>
              <CapitalizeFirst>
                {translations?.['b2c.txt.totalTicket']?.replace(
                  '${amount}',
                  `${getTotalAmount(ticket?.ticketsInfo ?? [])}`,
                )}
              </CapitalizeFirst>
            </StyledH4>
          </div>
          <div ref={ticketListAnchorTable} />
          <StyledTable
            dataSource={ticket.ticketsInfo.map((val, valIdx) => {
              return { ...val, ticket: val?.orgTickets?.[0] };
            })}
            columns={columns as object[]}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['20', '50', '100'],
              onChange: onScrollIntoElementTicketList,
            }}
            tableProps={{
              rowKey: (record, index) =>
                `${(record as TicketType)._id}${index}`,
            }}
            styleSlots={{
              td: {
                padding: '15px 10px',
              },
            }}
            scroll={{}} //ko dc xoa
          // tableProps={rowKey:(record, index) => `${(record as TicketType)._id}${index}`}
          />
        </>
      )}
      {listCustomers.length > 0 && (
        <>
          <div>
            <StyledH4 style={{ marginTop: 40, marginBottom: 24 }}>
              {translations ? translations['b2b.txt.listCustomer'] : ''}
            </StyledH4>
          </div>
          <div ref={listCustomerAnchorTable} />
          <StyledTable
            dataSource={
              (listCustomers?.filter(
                val => Boolean(val?.email) || val?.identityCode,
              ) ?? []) as object[]
            }
            columns={columnsCustomer as object[]}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['20', '50', '100'],
              onChange: onScrollIntoElementListCustomer,
            }}
            tableProps={{
              rowKey: (record, index) =>
                `${(record as TicketType)._id}${index}`,
            }}
            styleSlots={{
              td: {
                padding: '15px 10px',
              },
            }}
          // tableProps={rowKey:(record, index) => `${(record as TicketType)._id}${index}`}
          />
        </>
      )}
    </>
  );
};

interface ConfirmOrderBlockProps {
  idHash: string;
  getOrderDetail: (idHash) => Promise<any>;
  setWarningMsg: Dispatch<SetStateAction<string>>;
}

const ConfirmOrderBlock: React.FC<ConfirmOrderBlockProps> = props => {
  const { idHash, getOrderDetail, setWarningMsg } = props;
  const [isProcessing, setIsProcessing] = useState(false);

  const translations = useSelector(selectTranslations);

  const { handleAcceptOrder, handleRejectOrder, approvalType } =
    useApproveOrder({
      acceptOrder: {
        onBefore: () => setIsProcessing(true),
        onSuccess: async () => {
          try {
            await getOrderDetail(idHash);
          } catch (error) {
          } finally {
            setIsProcessing(false);
            setWarningMsg(translations?.['b2b.txt.approvalSucc'] ?? '');
          }
        },
        onError: async error => {
          try {
            await getOrderDetail(idHash);
          } catch (error) {
          } finally {
            setIsProcessing(false);
            setWarningMsg(error?.message);
          }
        },
      },
      rejectOrder: {
        onBefore: () => setIsProcessing(true),
        onSuccess: async () => {
          try {
            await getOrderDetail(idHash);
          } catch (error) {
          } finally {
            setIsProcessing(false);
            setWarningMsg(translations?.['b2b.txt.refuseSucc'] ?? '');
          }
        },
        onError: async error => {
          try {
            await getOrderDetail(idHash);
          } catch (error) {
          } finally {
            setIsProcessing(false);
            setWarningMsg(error?.message);
          }
        },
      },
    });

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ marginTop: 40 }}
      >
        <StyledButton
          textColor="#808080"
          border="solid 1px #808080"
          bgColor="#fff"
          onClick={handleRejectOrder.bind(null, idHash)}
          style={{ fontSize: 16 }}
        >
          {approvalType === 'REJECT' && isProcessing
            ? 'Loading...'
            : translations?.['b2b.approvalStt.refuse']}
        </StyledButton>
        <StyledButton
          textColor="#fff"
          onClick={handleAcceptOrder.bind(null, idHash)}
          style={{ fontSize: 16, marginLeft: 14 }}
        >
          {approvalType === 'ACCEPT' && isProcessing
            ? 'Loading...'
            : translations?.['b2b.btn.accept']}
        </StyledButton>
      </div>
    </>
  );
};

export const DetailTicketWrapper = () => {
  const translations = useSelector(selectTranslations);
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const [warningMsg, setWarningMsg] = useState('');
  const idHash = (params as any)?.idHash;
  const searchParams = new URLSearchParams(location.search);
  const prevScreen = searchParams.get('prevScreen');
  const isFromEmail = useRef(searchParams.get('fromEmail') === 'true');
  const [screen, setScreen] = useState<string>();
  const [ticket, setTicket] = useState<TicketType>();

  const { getDetailTicket } = useGetDetailTicket({
    screen: '/approve-order',
  });

  const getOrderDetail = useCallback(
    async idHash => {
      if (!idHash) return;
      const detailTicketData = await getDetailTicket(idHash);
      history.replace('/order-detail', {
        ticket: detailTicketData,
        screen: prevScreen ? `/${prevScreen}` : '/approve-order',
      });
    },
    [getDetailTicket, history, prevScreen],
  );

  useEffect(() => {
    getOrderDetail(idHash);
  }, [getOrderDetail, idHash]);

  const infoUser = useSelector(selectInfoUser);
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;
  const isDisplayConfirmOrderBlock =
    isSaleMng &&
    (ticket as any)?.subOrderState?.value === APPROVAL_ORDER_STATUS.PENDING;

  useEffect(() => {
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    if (historyState?.screen) {
      setScreen(historyState?.screen);
    }
    if (historyState?.ticket) {
      setTicket(historyState?.ticket);
    }
  }, [location?.state]);

  const menuActive = useMemo(() => {
    switch (screen) {
      case '/approve-order':
        return ACCOUNT_MNG_MENU.APPROVE_ORDER;
      case '/account':
        return ACCOUNT_MNG_MENU.PURCHASE_HISTORY;
      default:
        return ACCOUNT_MNG_MENU.CHECK_TICKET;
    }
  }, [screen]);

  return (
    <>
      <Layout
        title={translations ? translations['b2c.txt.detailOrder'] : ''}
        menuActive={menuActive}
        useBackArrow
        onBack={() => {
          if (menuActive === ACCOUNT_MNG_MENU.APPROVE_ORDER)
            history.replace('/approve-order');
          else if (
            menuActive === ACCOUNT_MNG_MENU.PURCHASE_HISTORY &&
            isFromEmail.current
          )
            history.replace('/account');
          else history.goBack();
        }}
        sufElement={
          isDisplayConfirmOrderBlock ? (
            <ConfirmOrderBlock
              idHash={(ticket as any)?.idHash}
              getOrderDetail={getOrderDetail}
              setWarningMsg={setWarningMsg}
            />
          ) : null
        }
      >
        {idHash ? (
          <LoadingContainer loading />
        ) : (
          ticket?.orderState?.value && (
            <DetailTicket orderState={ticket?.orderState?.value} />
          )
        )}
      </Layout>
      <WarningMsg
        content={warningMsg}
        onCloseModal={() => {
          setWarningMsg('');
        }}
      />
    </>
  );
};

export const AgentDetailTicketWrapper = () => {
  const translations = useSelector(selectTranslations);
  const location = useLocation();
  const history = useHistory();
  const [screen, setScreen] = useState<string>();
  const [ticket, setTicket] = useState<TicketType>();
  const { device } = useWindowSize();

  useEffect(() => {
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    if (historyState?.screen) {
      setScreen(historyState?.screen);
    }
    if (historyState?.ticket) {
      setTicket(historyState?.ticket);
    }
  }, []);
  return (
    <div style={{ maxWidth: 1920, margin: '0 auto' }}>
      <Col span={24} style={{ marginLeft: device === 'desktop' ? 25 : 0 }}>
        <div
          style={{
            borderRadius: 20,
            background: '#FFFFFF',
            padding: device === 'desktop' ? '40px 32px 32px' : '16px',
            boxShadow: '0px 20px 20px 0px #0000000D',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <StyledStack alignItem={'center'} columnGap={'5px'}>
            <ArrowDown
              onClick={() => history.push(screen ?? '')}
              style={{
                cursor: 'pointer',
                marginBottom: 14,
                height: 18,
                width: 18,
                transform: 'rotate(90deg)',
              }}
            />
            <StyledH4
              style={{
                marginBottom: 14,
                display: 'inline-block',
              }}
            >
              {translations ? translations['b2c.txt.detailOrder'] : ''}
            </StyledH4>
          </StyledStack>
          {ticket?.orderState?.value && (
            <DetailTicket orderState={ticket?.orderState?.value} />
          )}
        </div>
      </Col>
    </div>
    // <Layout
    //   title={translations ? translations['b2c.txt.detailOrder'] : ''}
    //   menuActive={
    //     screen === '/account'
    //       ? ACCOUNT_MNG_MENU.PURCHASE_HISTORY
    //       : ACCOUNT_MNG_MENU.CHECK_TICKET
    //   }
    //   useBackArrow
    //   onBack={() => {
    //     history.push(screen ?? '');
    //   }}
    // >

    // </Layout>
  );
};

export default DetailTicket;

const Key = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: black;
`;

const Value = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CouponContainer = styled.div<{ bgImg: string }>`
  /* display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 32px 0px 32px;
  background-image: url(${props => props.bgImg});
  height: 84.5px;
  background-repeat: no-repeat;
  background-size: 100%; */
  height: 68px;
  justify-content: space-between;
  border-radius: 5px;
  background-color: #fff8f8;
  position: relative;
  border: 1px solid #fdd7d7;
  padding: 14px 24px;
  margin: 14px 0px;
  display: flex;
  align-items: center;
  .title-voucher {
    font-size: 14px;
    font-weight: 500;
    color: #132639;
    margin-right: 12px;
  }
  ::after {
    position: absolute;
    content: '';
    height: 16px;
    right: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-left: 1px solid #fdd7d7;
  }

  ::before {
    position: absolute;
    content: '';
    height: 16px;
    left: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-right: 1px solid #fdd7d7;
  }

  @media (max-width: ${_ => TABLET_WIDTH}px) {
    height: 114px;
    padding: 0px;
    ::after {
      position: absolute;
      content: '';
      height: 16px;
      right: -8px;
      border-radius: 8px;
      z-index: 1;
      top: 49px;
      background-color: #ffffff;
      width: 16px;
      border-left: 1px solid #fdd7d7;
    }

    ::before {
      position: absolute;
      content: '';
      height: 16px;
      left: -8px;
      border-radius: 8px;
      z-index: 1;
      top: 49px;
      background-color: #ffffff;
      width: 16px;
      border-right: 1px solid #fdd7d7;
    }
  }
`;

const StyledH4 = styled.h4`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 32px;
  text-transform: uppercase;
  color: black;
`;

const TicketInfoContainer = styled.div`
  width: 100%;
  /* padding: 33px 34px 33px 34px; */
  background-color: #f7f7f7;
  border-radius: 20px;
`;

const TicketInfoContent = styled.div<{
  bgImg: string;
}>`
  display: flex;
  align-items: center;
  background-image: url(${props => props.bgImg});
  background-position: center right;
  background-repeat: no-repeat;
`;

const ListTicketCarousel = styled(Carousel)`
  .slick-dots {
    width: unset;
    /* button:before {
      content: '';
      width: 25px;
      height: 5px;
      border-radius: 10px;
      background: #fab317;
    } */
    /* .slick-active {
      button:before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: #c1c1c1;
      }
    } */
  }
  .ticket-dots {
    margin-left: 0;
    margin-right: 0;
    li {
      background: #c1c1c1;
      width: initial;
      height: 5px;
      width: 5px;
      border-radius: 50%;
      overflow: hidden;
      button {
        opacity: 0 !important;
        height: 5px;
        width: 5px;
        background: #c1c1c1;
        &::before {
          display: none;
        }
      }
      &.slick-active {
        width: 25px;
        background: #fab317;
        border-radius: 99px;
      }
    }
  }
  .slick-dots-bottom {
    bottom: -30px;
  }
`;

const CapitalizeFirst = styled.span`
  ::first-letter {
    text-transform: capitalize;
  }
`;
